import { render } from "./BaseInput.vue?vue&type=template&id=27ddb44d&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=27ddb44d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ddb44d"]])

export default __exports__